export const SvgIcon = (
  Icon: React.ComponentType<React.SVGProps<SVGSVGElement>> | undefined,
  attributes?: React.HTMLAttributes<SVGSVGElement>
) => {
  return Icon ? <Icon {...attributes} /> : null;
};
